// ─── Reference number priority helper ────────────────────────────────────────
// Priority: txn_ref_no_bank → txn_ref_no → reference_number
export const txnRefNum = (txn) =>
  txn.txn_ref_no_bank || txn.txn_ref_no || txn.reference_number || "—";

// ─── Formatters ──────────────────────────────────────────────────────────────

export const fmtINR = (val) =>
  Number(val || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

export const fmtDate = (str) => {
  if (!str) return "";
  // Handle Unix timestamps (seconds) — they arrive as numbers from newer records
  const d = typeof str === "number" ? new Date(str * 1000) : new Date(str);
  if (isNaN(d)) return String(str);
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const fmtTs = (ts) => {
  if (!ts) return "";
  const d = new Date(ts * 1000);
  if (isNaN(d)) return "";
  const date = d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
  const time = d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return `${date} · ${time}`;
};

// ─── Status badge colour map ──────────────────────────────────────────────────

export const STATUS_COLOUR = {
  "Bank Deposited":    "status-badge--green",
  Reconciled:          "status-badge--teal",
  "Handover Approved": "status-badge--blue",
  "Cash Collected":    "status-badge--grey",
  "Handover Requested":"status-badge--orange",
  "Deposit Requested": "status-badge--orange",
  "Branch Submitted":  "status-badge--orange",
  "Cash Submitted":    "status-badge--orange",
  "Collected":         "status-badge--blue",
  "Reversed":          "status-badge--red",
  "Reversal Requested":"status-badge--red",
  "In Progress":       "status-badge--grey",
  "Pending":           "status-badge--grey",
};

export const INVOLVEMENT_COLOUR = {
  "Collected":         "inv-badge--grey",
  "Handover Done":     "inv-badge--blue",
  "Handover Received": "inv-badge--green",
  "Deposited":         "inv-badge--teal",
  "Holding":           "inv-badge--orange",
  "Involved":          "inv-badge--grey",
};

// ─── Lifecycle step helpers ───────────────────────────────────────────────────
// Maps payment_staging.cash_transfer_log to_status codes to labels
export const LIFECYCLE_LABELS = {
  40:  "Cash Collected",
  70:  "Handover Requested",
  80:  "Handover Approved",
  90:  "Bank Deposit Requested",
  99:  "Reversed",
  100: "Bank Deposited",
  110: "Reconciled",
  55:  "Reversal Requested",
};

export const stepIcon = (step) => {
  const s = step.to_status;
  if (s === 99 || s === 55) return "icon--warning";
  if (s === 70 || s === 90) return "icon--pending";
  return "icon--done";
};

export const stepLabel = (step) =>
  step.status_label || LIFECYCLE_LABELS[step.to_status] || ("Status " + step.to_status);

// ─── Loan status helpers ──────────────────────────────────────────────────────
export const LOAN_STATUS_LABEL = {
  ACTIVE:      "Active",
  REVERSED:    "Reversed",
  SWAPPED_OUT: "Swapped Out",
  SWAPPED_IN:  "Swapped In",
};

export const LOAN_STATUS_COLOUR = {
  REVERSED:    "loan-badge--red",
  SWAPPED_OUT: "loan-badge--yellow",
  SWAPPED_IN:  "loan-badge--green",
};

/** Sum of ACTIVE + SWAPPED_IN loans — the effective visible amount. */
export const calcEffectiveAmount = function(loans) {
  if (!loans || loans.length === 0) return null;
  return loans.reduce(function(sum, l) {
    if (l.loan_status === "ACTIVE" || l.loan_status === "SWAPPED_IN") {
      return sum + (l.amount || 0);
    }
    return sum;
  }, 0);
};

// ─── Loan collection type labels ─────────────────────────────────────────────
export const COLLECTION_TYPE_LABEL = {
  P: "Principal",
  C: "Charges",
  F: "Foreclosure",
  A: "Advance",
};
